// extracted by mini-css-extract-plugin
export default {"checkboxes":"OlRd9kY59uMbow5LvxyA","subheader":"AgcGqGr8Wn9JWze_utqm"};